import React, { useEffect, useState } from 'react';
import { Avatar, Box, CircularProgress, Chip, Collapse, Divider, Typography, Tooltip } from '@mui/material';

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import Segmentacion from '../components/SearchPageComponents/SearchResults/Segmentacion';
import '../components/cardViews/cardViews.css';
import messengerIcon from '../assets/messenger.png';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

import RequestSvc from "../services/RequestSvc";
import CardViewAdDetail from "../components/cardViews/CardViewAdDetail";
import { FaGlobeAfrica } from 'react-icons/fa';
import { IconContext } from "react-icons";


/**
 * A simple, defensive component to display media for the error case.
 * It checks if the URL is for a video or an image.
 */
const AdMediaDisplay = ({ mediaUrl }) => {
    // Return nothing if the URL is invalid or missing
    if (!mediaUrl || typeof mediaUrl !== 'string') {
        return (
            <Box sx={{ p: 2, textAlign: 'center', backgroundColor: '#f0f0f0', borderRadius: '8px', m: 1 }}>
                <Typography variant="body2" color="textSecondary">
                    Media no disponible
                </Typography>
            </Box>
        );
    }

    const isVideo = ['.mp4', '.mov', '.webm'].some(ext => mediaUrl.toLowerCase().includes(ext));

    if (isVideo) {
        return (
            <video 
                src={mediaUrl} 
                controls 
                muted
                autoPlay
                loop
                style={{ width: '100%', display: 'block', borderRadius: '8px' }} 
            />
        );
    } else {
        return (
            <img 
                src={mediaUrl} 
                alt="Ad creative" 
                style={{ width: '100%', display: 'block', borderRadius: '8px' }} 
            />
        );
    }
};

/**
 * REFACCTORIZADO: Se ha mejorado el manejo de errores para que la UI
 * maneje una respuesta 200 OK que contenga un payload de error.
 */
export default function DetailsView({ item, launchCategoryDialog, isVault = false }) {

    const [selectedPost, setSelectedPost] = useState(null);
    const [showFullDescription1, setShowFullDescription1] = useState(false);
    const [expandTitle, setExpandTitle] = useState(false);
    const [copiedDescripcion, setCopiedDescripcion] = useState(false);
    const [copiedTitle, setCopiedTitle] = useState(false);
    const [segmentacion, setSegmentacion] = useState(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchAdsData = async (newItem) => {
        try {
            let svc = new RequestSvc();
            if (newItem.link_url) {
                let url = `https://test.tueducaciondigital.site/getfbads?pageID=${newItem.pageID}`;
                let result = await svc.get(url);
                if (result?.error) {
                    console.log("Failed to fetch secondary user data");
                } else {
                    setSegmentacion(result);
                }
            }
        } catch (err) {
            console.log("Error loading totals for segmentacion:", err);
        }
    };


    // --- API CALL REFACTOR ---
    useEffect(() => {
        const fetchAdDetails = async () => {
            setLoading(true);
            setError(null);
            let response;

            try {
                if(isVault) {
                    // obtiene datos de los anuncios  guardados por el usuario
                     response = await fetch(`https://tueducaciondigital.site/ads/getadssaveddetailsforcardview?ids=${item.LibraryID}`);
                     //response = await fetch(`http://localhost:3002/ads/getadssaveddetailsforcardview?ids=${item.LibraryID}`);

                } else {
                    // obtiene datos de los anuncios no guardados por el usuario
                     response = await fetch(`https://app.clicspy.com/ads/getadsdetailsforcardview?ids=${item.LibraryID}`);
                     
                                             
                     //response = await fetch(`http://localhost:3002/ads/getadsdetailsforcardview?ids=${item.LibraryID}`);
                }
                //const response = await fetch(`https://5g538fk2x4.execute-api.sa-east-1.amazonaws.com/getAdDetailsCardViewSaoPablo/getadsdetailsforcardview?ids=${item.LibraryID}`);
                
                const result = await response.json();

                if (result.error || result.data.length === 0) {
                    console.error("API returned an error payload:", result.error);
                    setError({ type: 'API_ERROR', message: "META YA NO TIENE INFORMACION DE ESTE ANUNCIO" });
                } else {
                    setShowFullDescription1(false);
                    let details = result.data[0];
                    if (details.AdCreative === null || details.AdCreative === "") {
                        details.AdCreative = item.AdCreative;
                        details.AdMedia = item.AdMedia;
                    }
                    setSelectedPost(details);
                    fetchAdsData(details);
                }

            } catch (err) {
                console.error("Fatal error fetching ad details:", err);
                setError({ type: 'GENERIC_ERROR', message: "Ocurrió un error de red al cargar los detalles." });
            } finally {
                setLoading(false);
            }
        };

        if (item && item.LibraryID) {
            fetchAdDetails();
        } else {
            setLoading(false);
            setError({ type: 'MISSING_ID', message: 'No se proporcionó un ID de anuncio válido.' });
        }
    }, [item]);


    const handleCopyToClipboard = (textToClipboard, nameContainer) => {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = textToClipboard;
        const textToCopy = tempElement.innerText || tempElement.textContent;

        navigator.clipboard.writeText(textToCopy).then(() => {
            if (nameContainer === "Descripcion") {
                setCopiedDescripcion(true);
                setTimeout(() => setCopiedDescripcion(false), 1500);
            } else {
                setCopiedTitle(true);
                setTimeout(() => setCopiedTitle(false), 1500);
            }
        }).catch((err) => console.error("Error al copiar al portapapeles:", err));
    };

    const getDomainFromUrl = (url) => {
        try {
            const parsedUrl = new URL(url);
            return parsedUrl.hostname;
        } catch (error) {
            return null;
        }
    };


    // --- FINAL Error Display Logic ---
    return (
        <div className={"card-view-ad-layout-main-detail"}>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                    <CircularProgress />
                </Box>
            ) : error ? (
                // Use the new, robust error display
                <Box className="card-container-details">
                    <AdMediaDisplay mediaUrl={item?.AdMedia} />
                    <Box sx={{ p: 2, textAlign: 'center', mt: 1 }}>
                        <Typography variant="h6" color="error">
                            {error.message}
                        </Typography>
                    </Box>
                </Box>
            ) : (
                selectedPost && (
                    <Box className="card-container-details">
                        <Box sx={{ display: 'flex', pt: 1, pb: 1 }}>
                            <Box display="flex" alignItems="center" gap={1}>
                                {selectedPost?.pageID && (
                                    <a
                                        href={`https://www.facebook.com/ads/library/?active_status=active&ad_type=all&country=ALL&media_type=all&search_type=page&view_all_page_id=${selectedPost.pageID}`}
                                        target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}
                                    >
                                        <Avatar src={selectedPost.page_profile_picture_url || ''} alt={selectedPost.pageName || 'Page Avatar'} sx={{ ml: 1 }} />
                                    </a>
                                )}
                                <Box>
                                    <Typography fontSize="14px" fontWeight="bold">
                                        {selectedPost?.pageID ? (
                                            <a href={`https://www.facebook.com/ads/library/?active_status=active&ad_type=all&country=ALL&media_type=all&search_type=page&view_all_page_id=${selectedPost.pageID}`}
                                                target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}
                                            >
                                                {selectedPost.pageName || 'Untitled Page'}
                                            </a>
                                        ) : 'Untitled Page'}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        <CardViewAdDetail item={selectedPost} launchCategoryDialog={launchCategoryDialog} isVault={isVault} />

                        <Box display="grid" sx={{ m: 1 }}>
                            <Box display={'flex'} sx={{ alignItems: 'center', mt: 1 }}>
                                <Typography fontSize="14px" fontWeight="bold">Texto principal</Typography>
                                {selectedPost?.__html && (
                                    <Tooltip title={copiedDescripcion ? "Copiado!" : "Copiar"} open={copiedDescripcion} placement="top" arrow>
                                        <ContentCopyOutlinedIcon sx={{ ml: 1, cursor: 'pointer' }} onClick={() => handleCopyToClipboard(selectedPost.__html, "Descripcion")} />
                                    </Tooltip>
                                )}
                            </Box>
                            <Collapse collapsedSize={24} in={showFullDescription1}>
                                <Typography
                                    fontSize="12px"
                                    className={showFullDescription1 ? 'card-details-descriptions' : 'card-details-descriptions close'}
                                    mt={1}
                                    dangerouslySetInnerHTML={{ __html: (selectedPost?.__html && !selectedPost.__html.includes("product.")) ? selectedPost.__html : "" }}
                                />
                            </Collapse>
                            {selectedPost?.__html && selectedPost.__html.length > 80 && (
                                <Typography
                                    onClick={() => setShowFullDescription1(!showFullDescription1)}
                                    sx={{ width: '110px', color: 'black', mt: 1, fontWeight: 'bold', cursor: 'pointer' }}
                                >
                                    {showFullDescription1 ? 'Mostrar menos' : '...más'}
                                </Typography>
                            )}
                        </Box>

                        {selectedPost?.title && selectedPost.title !== '' && (
                            <Box display="grid" alignItems="center" sx={{ m: 1 }}>
                                <Box display={'flex'} sx={{ alignItems: 'center', mt: 1 }}>
                                    <Typography fontSize="14px" fontWeight="bold">Título</Typography>
                                    <Tooltip title={copiedTitle ? "Copiado!" : "Copiar"} open={copiedTitle} placement="top" arrow>
                                        <ContentCopyOutlinedIcon sx={{ ml: 1, cursor: 'pointer' }} onClick={() => handleCopyToClipboard(selectedPost.title, "Title")} />
                                    </Tooltip>
                                </Box>
                                <Collapse collapsedSize={28} in={expandTitle}>
                                    <Typography fontSize="12px" sx={{ mt: 1 }}>
                                        {!selectedPost.title?.includes("product.") ? selectedPost.title : ""}
                                    </Typography>
                                </Collapse>
                                {selectedPost.title.length > 70 && (
                                    <Chip
                                        size={'medium'}
                                        label={expandTitle ? 'Mostrar menos' : 'Ver más'}
                                        onClick={() => setExpandTitle(!expandTitle)}
                                        sx={{ width: '110px', color: 'black', mt: 1, fontWeight: 'bold' }}
                                    />
                                )}
                            </Box>
                        )}

                        <Divider />

                        <Box display="flex" alignItems="center" gap={1} sx={{ m: 1 }}>
                            <Typography fontSize="14px" fontWeight="bold">Plataformas:</Typography>
                            {selectedPost.publisherPlatform?.includes('instagram') && <InstagramIcon />}
                            {selectedPost.publisherPlatform?.includes('facebook') && <FacebookRoundedIcon />}
                            {selectedPost.publisherPlatform?.includes('messenger') && (
                                <img src={messengerIcon} alt={'messenger icon'} style={{ width: '20px', height: '20px' }} />
                            )}
                        </Box>

                        {selectedPost?.LibraryID && (
                            <Box display="flex" alignItems="center" gap={1} sx={{ m: 1 }}>
                                <Typography fontSize="14px" fontWeight="bold">Identificador del anuncio:</Typography>
                                <a
                                    id="watchAd"
                                    href={`https://www.facebook.com/ads/library/?active_status=ALL&ad_type=all&country=ALL&q=${selectedPost.LibraryID}`}
                                    target="_blank" rel="noopener noreferrer"
                                >
                                    {selectedPost.LibraryID}
                                </a>
                            </Box>
                        )}

                        {selectedPost?.link_url && (
                            <Box display="flex" alignItems="center" gap={2} sx={{ m: 1, p: 1, border: 1, borderRadius: '4px', borderColor: 'grey.300' }}>
                                <a href={selectedPost.link_url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                    <OpenInNewIcon />
                                </a>
                                <Typography width="100%" maxWidth="200px" overflow="hidden" whiteSpace={"nowrap"} textOverflow="ellipsis">
                                    {selectedPost.link_url}
                                </Typography>
                                {selectedPost.cta_text && (
                                    <a href={selectedPost.link_url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                        <Chip label={selectedPost.cta_text} sx={{ border: 1, borderRadius: '4px', borderColor: 'grey.300', background: 'transparent', position: 'absolute', right: 1, mr: '56px', mt: '-15px' }} />
                                    </a>
                                )}
                                <IconContext.Provider value={{ size: "24px", style: { position: 'absolute', right: 1, marginRight: '16px' } }}>
                                    {getDomainFromUrl(selectedPost.link_url) && (
                                        <Tooltip title="Buscar en la biblioteca todos los anuncios que contengan este Dominio">
                                            <a id="watchAd" href={`https://www.facebook.com/ads/library/?active_status=ALL&ad_type=all&country=ALL&q="${getDomainFromUrl(selectedPost.link_url)}"`}
                                               target="_blank" rel="noopener noreferrer"
                                            >
                                                <FaGlobeAfrica style={{ marginTop: '-10px' }} />
                                            </a>
                                        </Tooltip>
                                    )}
                                </IconContext.Provider>
                            </Box>
                        )}

                        {segmentacion && (
                            <div style={{ marginTop: '20px' }}>
                                <Segmentacion selectedPost={segmentacion} />
                            </div>
                        )}
                    </Box>
                )
            )}
        </div>
    );
}
